import React, { useCallback, useContext, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

import Icon from 'components/Icon';
import { BodyOverflowContext } from 'contexts/BodyOverflowContext';

import styles from './styles.module.scss';

const Search = ({ onChange, onRequestClose, tabIndex }) => {
	const [, setBodyOverflowIsHidden] = useContext(BodyOverflowContext);
	const inputRef = useRef(null);
	const container = document.querySelector('#wrap');

	const onKeyDown = useCallback(
		(event) => {
			if (event.key === 'Enter') {
				event.preventDefault();

				onChange?.(event.currentTarget.value);
			} else if (event.key === 'Escape' || event.key === 'Esc') {
				onRequestClose?.();
			}
		},
		[onRequestClose, onChange]
	);

	useEffect(() => {
		setBodyOverflowIsHidden('search', true);
		inputRef.current.focus();

		const onEscKeyDown = (event) => {
			if (event.key === 'Escape' || event.key === 'Esc') {
				onRequestClose?.();
			}
		};

		document.addEventListener('keydown', onEscKeyDown);

		return () => {
			setBodyOverflowIsHidden('search', false);

			document.removeEventListener('keydown', onEscKeyDown);
		};
	}, []);

	const renderSearch = () => (
		<div className={styles.search}>
			<div className={styles.inner}>
				<div className={styles.form}>
					<div className={styles.field}>
						<Icon icon="search" className={styles.icon} />
						<input
							className={styles.control}
							ref={inputRef}
							onKeyDown={onKeyDown}
							placeholder="Поиск"
							tabIndex={tabIndex}
							type="search"
						/>
					</div>
				</div>
				<button
					className={styles.close}
					type="button"
					onClick={onRequestClose}
					title="Закрыть"
					tabIndex={tabIndex}
				>
					<Icon icon="close" inheritSize={false} />
				</button>
			</div>
		</div>
	);

	return ReactDOM.createPortal(renderSearch(), container);
};

Search.propTypes = {
	onChange: PropTypes.func,
	onRequestClose: PropTypes.func,
	tabIndex: PropTypes.number
};

export default Search;
